module.exports = __webpack_public_path__ + "common/icon-my-flag-27f82fff524bed259de9af4910fa0c7d.svg";